import { Grid, Typography, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { isEmpty } from "lodash";
import { getData, storeData } from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import clsx from "clsx";
import Configs from "../../constants/Configs";
import DialogError from "../../components/CustomDialog/DialogWait";
import GlobalApi from "../../utils/GlobalApi";
import Loading from "../../components/loading/loading";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";

const useStyle = makeStyles({
  font: {
    fontFamily: "DB Heavent",
  },
  content: {
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "var(----text-black)",
  },
  bt25: {
    marginBottom: "35px",
  },
});

const Questions = (props) => {
  const classes = useStyle();
  const checkuserinfo = getData("checkuserinfo");
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const { cardId, aeCode } = checkuserinfo;
  const [checked, setChecked] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [questionsData, setQuestionsData] = useState([]);
  const [questionsAnswer, setQuestionsAnswer] = useState([
    {
      SAfsac_Id: "7765",
      SAfsac_SAmsa_Id: "1",
      SAfsac_Answer: "1",
    },
    {
      SAfsac_Id: "7766",
      SAfsac_SAmsa_Id: "2",
      SAfsac_Answer: "1",
    },
    {
      SAfsac_Id: "7767",
      SAfsac_SAmsa_Id: "3",
      SAfsac_Answer: "1",
    },
    {
      SAfsac_Id: "7768",
      SAfsac_SAmsa_Id: "4",
      SAfsac_Answer: "1",
    },
    {
      SAfsac_Id: "7769",
      SAfsac_SAmsa_Id: "5",
      SAfsac_Answer: "",
    },
  ]);
  const [translations, setTranslations] = useState("");
  const [jumpPage, setJumpPage] = useState(false);

  const header = {
    headers: {
      Accept: "application/json",
    },
  };
  const checkJumpPage = async () => {
    if (isEmpty(checkuserinfo)) {
      return true;
    } else {
      return false;
    }
  };

  const handleNext = (e) => {
    e.preventDefault();
    storeData("questionsAnswer", questionsAnswer);
    props.history.push("/termandcon");
  };

  const getQuestion = async () => {
    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/questions/selbyidentity`,
        { id_card: cardId, aecode: aeCode ? aeCode : "null" },
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res.data.Data) {
            setQuestionsData(res.data.Data);
          } else {
            setIsModalError(true);
          }
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsModalError(true);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      setIsModalError(true);
    }
  };

  const handleChoose = async (id, choice, i) => {
    let answer = questionsAnswer;
    if (choice === 2) {
      if ([2, 3].includes(id)) {
        let stp = id === 2 ? "3" : "1";
        let errCode = id === 2 ? "3003" : "3001";
        let data = {};
        data.head_token = !isEmpty(head_token) ? head_token : "";
        data.card_id = !isEmpty(checkuserinfo?.cardId)
          ? checkuserinfo?.cardId
          : "";
        data.stamp_page = stp;
        data.error_code = errCode;
        let upd = await updateTracking(data);
        if (upd) {
          setModalErrorDes(
            "ไม่สามารถเปิดบัญชีออนไลน์ได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
          );
          setModalErrorTitle("ขออภัย");
          setIsModalError(true);
        } else {
          setModalErrorTitle("เกิดข้อผิดพลาด");
          setModalErrorDes("กรุณาทำรายการใหม่อีกครั้ง");
          setIsModalError(true);
        }
      } else {
        setModalErrorDes(
          "ไม่สามารถเปิดบัญชีออนไลน์ได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
        );
        setModalErrorTitle("ขออภัย");
        setIsModalError(true);
      }
      answer[i].SAfsac_Answer = "";
    } else {
      answer[i].SAfsac_Answer = choice.toString();
    }
    setQuestionsAnswer([...questionsAnswer]);
    checkQuestion();
  };

  const checkQuestion = async () => {
    let error = 0;
    questionsAnswer.forEach((element) => {
      if (element.SAfsac_Answer === "") {
        error = error + 1;
      } else {
        if (
          ["1", "2", "3", "4"].includes(element.SAfsac_SAmsa_Id) &&
          element.SAfsac_Answer === "2"
        ) {
          error = error + 1;
        }
      }
    });
    if (error > 0) {
      setChecked(false);
    } else {
      setChecked(true);
    }
  };

  const updateTracking = async (data) => {
    let upd = false;
    if (!isEmpty(data)) {
      try {
        await GlobalApi.post(
          Configs.baseAPIURL03 + "/form/header/update_tracking",
          data,
        )
          .then((res) => {
            let result = res.data.Data[0][0];
            upd = result.MsgDesc.includes("Success") ? true : false;
          })
          .catch((error) => {
            if (!!error.isAxiosError && !error.response) {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes("กรุณาทำรายการใหม่อีกครั้ง");
              setIsModalError(true);
            } else {
              let errorMessage = error.response
                ? error.response.data.message
                : "";
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(`axios or api error ${errorMessage}`);
              setIsModalError(true);
            }
          });
      } catch (error) {
        setModalErrorTitle("เกิดข้อผิดพลาด");
        setModalErrorDes("กรุณาทำรายการใหม่อีกครั้ง");
        setIsModalError(true);
      }
    }
    return upd;
  };

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        setIsLoading(true);
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        getQuestion();
        const questionsAnswer = getData("questionsAnswer");
        if (questionsAnswer) {
          setQuestionsAnswer(questionsAnswer);
          let error = 0;
          questionsAnswer.forEach((element) => {
            if (element.SAfsac_Answer === "") {
              error = error + 1;
            } else {
              if (
                ["1", "2", "3", "4"].includes(element.SAfsac_SAmsa_Id) &&
                element.SAfsac_Answer === "2"
              ) {
                error = error + 1;
              }
            }
          });
          if (error > 0) {
            setChecked(false);
          } else {
            setChecked(true);
          }
        } else {
          checkQuestion();
        }
      }
    });
  }, []);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            clickBack={(e) => (e ? props.history.push("/checkuserinfo") : "")}
            title={translations?.[lang]?.questions?.title}
            onChangeLang={(e) => setLang(e)}
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.questions}
                        clickBack={(e) => props.history.push("/checkuserinfo")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                     
                        <Grid
                          className="box-right-content-q pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                             <HeaderRight
                          isQuestions
                          title={translations?.[lang]?.questions?.title}
                        />
                          <ScrollBarComponent
                            content={
                              <Grid container>
                                <Grid className="sub-title">
                                  <Typography className="box-title text-left font-20">
                                    {translations?.[lang]?.questions?.sub_title}
                                  </Typography>
                                </Grid>
                                <Grid className={classes.content}>
                                  <Grid
                                    className={clsx(classes.font, "font-20")}
                                  >
                                    {questionsData?.map((items, i) => (
                                      <Grid key={i}>
                                        <Grid className={clsx(classes.bt25)}>
                                          <Typography className="text-primary font-weight-bold font-20">
                                            {items?.SAmppr_Question}
                                          </Typography>
                                        </Grid>
                                        <Grid className="btn-box">
                                          {items?.SAmppr_Answer?.map(
                                            (sub_items, j) => (
                                              <Button
                                                key={j}
                                                onClick={() => {
                                                  handleChoose(
                                                    items.SAmppr_Id,
                                                    sub_items.ChoiceID,
                                                    i,
                                                  );
                                                }}
                                                className={clsx(
                                                  "btn-left btn-next font-20",
                                                  questionsAnswer[i]
                                                    .SAfsac_Answer ===
                                                    sub_items.ChoiceID.toString() &&
                                                    "enabled-btn-right",
                                                )}
                                              >
                                                {sub_items?.Text}
                                              </Button>
                                            ),
                                          )}
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                          />
                          {/* check box content */}
                          {/* button */}
                          <Grid className="btn-box">
                            <Button
                              className={clsx(
                                !checked
                                  ? "disabled-btn-right"
                                  : "enabled-btn-right",
                                "btn-primary font-20",
                              )}
                              disabled={!checked}
                              onClick={handleNext}
                            >
                              {translations?.[lang]?.questions?.accept}
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(Questions);
